import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'
import Input from '../../form/Input'

const SlideSettingsModal = ({ store }) => (
    <Modal
        show={store.slideSettingsModalOpen}
        onClose={store.handleCloseSlideSettingsModal}
    >
        <Typography type="h2">{i18n.t('powerpoint.modals.slide.title')}</Typography>

        <br />

        <Input
            label={i18n.t('powerpoint.modals.slide.slide-title')}
            onBlur={store.editSlideTitle}
            defaultValue={store.activeSlide?.title}
            disabled={store.activeSlide?.template !== 'sectionHeader'}
        />

        <ModalFooter>
            <Button
                label={i18n.t('save')}
                icon="fal fa-save"
                cssClass="regular primary"
                onClick={store.handleCloseSlideSettingsModal}
            />
        </ModalFooter>
    </Modal>
)

export default observer(SlideSettingsModal)
